import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(14,1fr)',
    height: 30
  },
  skeletonContainer: {
    background: theme.palette.grey[100],
    padding: '0px 10px'
  },
  skeletonContainerEven: {
    background: theme.palette.grey[300]
  },
  skeleton: {
    width: '100%'
  }
}))

export default useStyles
